import React from 'react'
import { Link } from 'react-router-dom'
import 'moment/locale/it'
import { PERMISSIONS, USER } from '../../../django'
import DateRangeQsFilter from '../DateRangeQsFilter'
import ClientiSelectAutoComplete from '../../ClientiSelectAutoComplete'

const FiltersOrders = ({
  filters,
  onFilterChangeDebounced,
  onFilterChange,
  onFiltersChange,
  totals,
  pagination,
}) => {
  const { search = '', scheduled = '', commessa_interna = '', reynaers = '' } = filters || {}

  return (
    <div>
      {/* MOBILE: 3 filtri (cliente, data ordine, ricerca libera) sopra ai totali */}
      <div className="filters-fixed-bar d-md-none">
        <div className="filters-fixed-bar__inner">
          <input
            name="search"
            type="text"
            className="form-control form-control-sm"
            placeholder="Ricerca libera"
            value={filters?.search || ''}
            onChange={onFilterChangeDebounced}
          />

          <DateRangeQsFilter
            filters={filters}
            onFiltersChange={onFiltersChange}
            startField="from_data"
            endField="to_data"
            withPortal={true}
            customArrowIcon={<div />}
            small={false}
            noBorder
          />
          <div style={{ zIndex: 2 }}>
            <ClientiSelectAutoComplete
              value={filters.cliente || null}
              hasValue
              label=""
              agente_id={
                USER.agente ? USER.agente.id : null
              } /* Se l'utente è un agente, filtro i clienti in base al suo id */
              required
              debounceTimeout={150}
              loadOptionsOnMenuOpen
              withPortal
              onChange={(cliente) => {
                if (cliente) {
                  onFilterChange(cliente, 'cliente')
                } else {
                  onFilterChange('', 'cliente')
                }
              }}
              noOptionsMessage={() => 'Nessun cliente trovato'}
              loadingMessage={() => 'Caricamento clienti...'}
              placeholder={'Seleziona cliente'}
              isClearable={true}
              name={'cliente'}
              additional={{
                page: 1,
              }}
            />
          </div>
        </div>
      </div>

      {/* DESKTOP: filtri originali */}
      <div className="row pt-2">
        <div className="col-md-2 mb-2 mb-md-0 d-none d-md-block">
          <input
            name="search"
            type="text"
            className="form-control form-control-sm"
            placeholder="Ricerca libera"
            value={search}
            onChange={onFilterChangeDebounced}
          />
        </div>

        <div className="col-md-2 mb-2 mb-md-0 d-none d-md-block">
          <select
            name="scheduled"
            onChange={onFilterChange}
            value={scheduled}
            className="form-control form-control-sm"
          >
            <option value="">Tutti (schedulati e non)</option>
            <option value="1">Schedulati</option>
            <option value="0">Non schedulati</option>
            <option value="non_schedulabili">Non schedulabili</option>
          </select>
        </div>

        <div className="col-md-1 mb-2 mb-md-0 d-none d-md-block">
          <select
            name="commessa_interna"
            onChange={onFilterChange}
            value={commessa_interna}
            className="form-control form-control-sm"
          >
            <option value="">Tutti</option>
            <option value="1">Solo commesse interne</option>
            <option value="0">Escludi commesse interne</option>
          </select>
        </div>

        <div className="col-md-1 mb-2 mb-md-0 d-none d-md-block">
          <select
            name="reynaers"
            onChange={onFilterChange}
            value={reynaers}
            className="form-control form-control-sm"
          >
            <option value="">Tutti (alluminio e legno)</option>
            <option value="1">Ordini alluminio</option>
            <option value="0">Ordini legno</option>
          </select>
        </div>

        <div className="col-md-3 align-items-center d-none d-md-flex">
          {pagination && (
            <div>
              Totale Ordini:{' '}
              <span className="badge badge-primary">{pagination.count}</span>
            </div>
          )}
        </div>

        {PERMISSIONS.addOrders && (
          <div className="col-md-3 text-right">
            <Link
              className="btn btn-sm btn-outline-dark mr-1"
              to="/importa-ordini"
            >
              <i className="fas fa-upload"></i> Importa ordini
            </Link>
            <Link className="btn btn-sm btn-outline-dark" to="/aggiungi-ordine">
              <i className="fas fa-plus-circle"></i> Aggiungi ordine
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default FiltersOrders
